import type { Review } from '@/shared/api/experience';
import type { ExperienceReview } from '@/entities/review';

export const reviewExperienceCards = (reviews: Array<Review> | undefined): ExperienceReview[] => {
  if (!reviews?.length) {
    return [];
  }

  return reviews
    .filter((review) => review?.experience?.is_bookable)
    .map(
      (review: Review): ExperienceReview => ({
        id: review?.id as number,
        title: review.experience?.title ?? '',
        link: review?.experience?.url ?? '',
        experienceId: review?.experience?.id ?? 0,
        experienceFormat: review?.experience?.format ?? '',
        experienceType: review?.experience?.type ?? '',
        name: review?.name ?? '',
        avatar: review?.avatar?.small ?? review?.avatar?.medium ?? '',
        rating: review.rating ?? 0,
        date: review?.created_at ?? '',
        text: review.text ?? '',
        photos: review.photos ?? [],
        guide_reply: review.guide_reply ?? null,
        travelerLevel: review?.traveler_level ?? 0,
        photosInProcessing: Boolean(review?.is_showing_processing_photos),
        isDisabledExpand: false,
      }),
    );
};
